import { selectors as requestSelectors } from "redux-request-state";

const allBase = state => state.sources;
export const isLoadingSources = requestSelectors.isLoading( allBase );
export const getSources = requestSelectors.getData( allBase );